import { WidgetType } from './widgetType';
export var FlipCardType;
(function (FlipCardType) {
    FlipCardType["text"] = "text";
    FlipCardType["imageFull"] = "imageFull";
})(FlipCardType || (FlipCardType = {}));
export const FlipCardWidgetHelper = {
    isFlipCardWidget: (widget) => {
        return widget.value.type === WidgetType.flipCard;
    },
    isFlipCardServerData: (widget) => {
        return widget.type === WidgetType.flipCard;
    },
    makeDefaultProperties: () => ({
        displayDelayInSeconds: 0,
        isRequired: false,
    }),
    createBasicFlipCard: () => ({
        front: { type: FlipCardType.text, text: 'This is front of your card' },
        back: { type: FlipCardType.text, text: 'This is back of your card' },
    }),
};
